import {
  CheckboxFacetGroup,
  FacetOption,
} from '@tailwindComponents/CheckboxFacetGroup';
import { RailPanel } from '@tailwindComponents/RailPanel';
import {
  CustomerFacetState,
  CustomerHierarchyTree as HierarchyTree,
} from './customerFacets';
import { CustomerHierarchyTree } from './CustomerHierarchyTree';

export interface CustomerFacetRailProps {
  tree: HierarchyTree;
  facets: CustomerFacetState;
  onSelectAll: () => void;
  onSelectGroup: (groupName: string) => void;
  onSelectSubNode: (groupName: string, subNodeName: string) => void;
  onSelectIndependents: () => void;
  onSelectUnassigned: () => void;
  channelOptions: FacetOption[];
  onToggleChannel: (value: string) => void;
}

export function CustomerFacetRail({
  tree,
  facets,
  onSelectAll,
  onSelectGroup,
  onSelectSubNode,
  onSelectIndependents,
  onSelectUnassigned,
  channelOptions,
  onToggleChannel,
}: CustomerFacetRailProps) {
  return (
    <aside className='flex w-[260px] shrink-0 flex-col gap-4'>
      <RailPanel title='Customer hierarchy' tagline='market-scoped'>
        <CustomerHierarchyTree
          tree={tree}
          facets={facets}
          onSelectAll={onSelectAll}
          onSelectGroup={onSelectGroup}
          onSelectSubNode={onSelectSubNode}
          onSelectIndependents={onSelectIndependents}
          onSelectUnassigned={onSelectUnassigned}
        />
      </RailPanel>
      {channelOptions.length > 0 && (
        <RailPanel title='Channel' tagline='flat dimension'>
          <CheckboxFacetGroup
            options={channelOptions}
            selected={facets.channels}
            onToggle={onToggleChannel}
          />
        </RailPanel>
      )}
    </aside>
  );
}
